import React from 'react';
import styled from 'styled-components';

import { useAppDispatch } from './useAppDispatcher.hook';
import { getDepartmentListThunk } from '../redux/Department/Department.thunk';
import { Department } from '../redux/Department/Department.type';

const StyledSelectOption = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const useDepartmentHook = () => {
  const dispatch = useAppDispatch();

  return {
    getSelectList: async (
      search: string,
      loadedOptions: string | any[],
      { page }: any,
    ) => {
      const {
        payload: { data, pagination },
      } = await dispatch(getDepartmentListThunk({ page }));
      return {
        options: data.map((item: Department) => ({
          value: item.id,
          label: (
            <StyledSelectOption>
              <div>{item.name}</div>
            </StyledSelectOption>
          ),
        })),
        hasMore: pagination.current_page < pagination.last_page,
        additional: {
          page: pagination.current_page + 1,
        },
      };
    },
    getSelectListByIds: async (ids: Array<number>) => {
      const {
        payload: { data },
      } = await dispatch(getDepartmentListThunk({ ids }));
      return data.map((item: Department) => ({
        value: item.id,
        label: (
          <StyledSelectOption>
            <div>{item.name}</div>
          </StyledSelectOption>
        ),
      }));
    },
  };
};

export default useDepartmentHook;
